export const membershipPayment = {
  formTitle:
    "Enter your payment information below. <nobr>(You won’t be charged for two weeks.)</nobr>",
  planInfo: {
    plus: {
      title: "$t(common.plans.plus): ${{price}}/mo",
    },
    premium: {
      title: "$t(common.plans.premium): ${{price}}/mo",
    },
  },
  promoCode: {
    add: "Add promo code",
    apply: "Apply",
    applyOrClear: "Apply or clear promotion code to continue.",
    coupon:
      "This reflects the price for the first {{durationInMonths}} month(s) of your subscription. After that, the price will be ${{fullPrice}}/month.",
    remove: "Remove",
  },
  payment: {
    submit: "Start your membership",
    terms:
      "By clicking “Start your membership” you acknowledge and agree that you are over 18, that you will be charged for your first term immediately, and that you will be charged the subscription amount each subscription term to your active payment method until your subscription is canceled. You may cancel at any time on your account settings page; you must cancel your subscription before it renews to avoid the billing of the next subscription fee to your active payment method. All payments made prior to cancellation are non-refundable.",
  },
  resubscribe: {
    submit: "Subscribe",
    terms:
      "By clicking “resubscribe” you acknowledge and agree that you are over 18, that you will be charged for you first month immediately, and that you will be charged the subscription amount each subscription term to your active payment method until your subscription is canceled. You may cancel at any time on your account settings page; you must cancel your subscription before it renews to avoid the billing of the next subscription fee to your active payment method. All payments made prior to cancellation are non-refundable.",
  },
  title: "Subscribe to unlock your plan",
};
